import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseServiceFacade, GenericApiCall } from '../../../common/store/types';
import { AppState } from '../types';
import { ChequeRemittanceModel } from './types';
import { chequeRemittanceActions } from './cheque-remittance.actions';
import { chequeRemittanceSelectors } from './cheque-remittance.selector';

@Injectable()
export class ChequeRemittanceService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }
  getById: GenericApiCall<ChequeRemittanceModel, string> = this.genericApiCall(
    chequeRemittanceActions.getById,
    chequeRemittanceSelectors.getById,
    true,
  );
  createInstance: GenericApiCall<ChequeRemittanceModel, void> =
    this.genericApiCall(
      chequeRemittanceActions.createInstance,
      chequeRemittanceSelectors.createInstance,
      true,
    );
  add: GenericApiCall<ChequeRemittanceModel, ChequeRemittanceModel> =
    this.genericApiCall(
      chequeRemittanceActions.add,
      chequeRemittanceSelectors.add,
      true,
    );
  delete: GenericApiCall<boolean, string> = this.genericApiCall(
    chequeRemittanceActions.delete,
    chequeRemittanceSelectors.delete,
    true,
  );
  deleteFromList: GenericApiCall<boolean, string> = this.genericApiCall(
    chequeRemittanceActions.deleteFromList,
    chequeRemittanceSelectors.deleteFromList,
    true,
  );
  getChequeRemittancePdf: GenericApiCall<any, number> = this.genericApiCall(
    chequeRemittanceActions.getChequeRemittancePdf,
    chequeRemittanceSelectors.getChequeRemittancePdf,
    true,
  );
}
